module.exports = __webpack_public_path__ + "img/relator.1e67af66.svg";